module.exports = __webpack_public_path__ + "img/thumb_12.a9e7f4e0.jpg";